var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', {
    ref: "wikiWrap",
    staticClass: "wikiViewerWrap"
  }, [_c('div', {
    ref: "wikiTitle",
    staticClass: "wikiTitle"
  }, [_c('div', {
    ref: "wikiHeader",
    staticClass: "wikiHeader",
    staticStyle: {
      "font-family": "NanumSquareEB, bold",
      "color": "#333",
      "font-size": "30px",
      "padding": "10px 0 10px 0"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.name)
    }
  }), _c('div', {
    staticStyle: {
      "font-family": "NanumSquare",
      "color": "#999",
      "font-size": "24px",
      "padding": "10px 0 10px 0"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.nameEng)
    }
  })]), _c('div', {
    ref: "scrollWrap",
    staticClass: "contentsWrap",
    on: {
      "scroll": _vm.moveScroll
    }
  }, [_c('br'), _c('section', {
    staticClass: "wikiContents",
    attrs: {
      "data-depth": "0"
    }
  }, [_vm.isProcess.isProcess ? _c('Process', {
    attrs: {
      "item": _vm.isProcess
    },
    on: {
      "load-content": function (status) {
        return _vm.awaitContent('process', status);
      }
    }
  }) : _vm._e()], 1), _c('section', {
    staticClass: "wikiContents",
    attrs: {
      "data-depth": "0"
    }
  }, [_vm.isKeyword.isKeyword ? _c('Keyword', {
    attrs: {
      "item": _vm.isKeyword,
      "readonly": true
    },
    on: {
      "load-content": function (status) {
        return _vm.awaitContent('keyword', status);
      }
    }
  }) : _vm._e()], 1), _vm._l(_vm.nodeData, function (data) {
    return _c('WikiContent', {
      attrs: {
        "editor": data
      }
    });
  })], 2), _c('Loading', {
    attrs: {
      "visible": _vm.loading
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }